<template>
  <div id="user-detail">
    <ol class="breadcrumb pull-right">
      <li><router-link :to="{path: '/'}">Home</router-link></li>
      <li><router-link :to="'/teachers'">Aktivasi Guru</router-link></li>
      <li class="active">Guru Detail</li>
    </ol>
    <!-- end breadcrumb -->
    <!-- begin page-header -->
    <h1 class="page-header">Informasi Detail Guru</h1>
    <!-- end page-header -->
    <div class="row">
      <div class="col-md-12">
        <!-- begin panel -->
        <div class="panel panel-inverse">
          <div class="panel-heading">
            <h4 class="panel-title">Guru Info</h4>
          </div>
          <div class="panel-body">
            <div class="media">
                <!-- <a href="javascript:;" class="media-left">
                  <img :src="organization.picture" alt="profile_picture" class="media-object">
                </a> -->
              <div class="media-body">
                <table class="table">
                  <tbody>
                    <tr>
                      <td style="width: 15%"><strong>Nama Guru</strong></td>
                      <td>{{ teacher.name }}</td>
                    </tr>
                    <tr>
                      <td><strong>No Pegawai</strong></td>
                      <td>
                        {{teacher.employee_id}}
                        </td>
                    </tr>
                    <tr>
                      <td><strong>Email</strong></td>
                      <td>{{ teacher.email }}</td>
                    </tr>
                    <tr>
                      <td><strong>Status</strong></td>
                      <td><span v-if="teacher.is_verified">Aktif</span>
                    <span style="color:red;" v-else>Terdaftar</span></td>
                    </tr>
                    <tr>
                      <td><strong>Tanggal Expired</strong></td>
                      <td><date-picker v-model="expiredAtModel" value-type="timestamp" valueType="format"></date-picker></td>
                    </tr>
                    <tr>
                      <td><strong>Mata Pelajaran</strong></td>
                      <td>
                        <button @click="removeMapel(item)" style="margin:0px 5px 5px 5px;" class="btn btn-info" v-for="(item, index) in teacher.scopes" :key="index">
                          {{ item.display_name }} <i class="fa fa-close"></i>
                        </button>
                          <button class="btn btn-primary dropdown-toggle" type="button" data-toggle="dropdown"><i class="fa fa-plus"></i>
                          </button>
                          <ul class="dropdown-menu" style="max-height:300px; overflow:auto !important;">
                            <li v-for="(item, index) in mapels" :key="index" @click="addMapel(item)"><a>{{item.displayName}}</a></li>
                          </ul>
                      </td>
                    </tr>
                    <tr>
                      <td colspan="2">
                        <button @click="updateTanggalScope(teacher)" class="btn btn-success pull-right">
                          {{ teacher.is_verified ? 'Simpan' : 'Aktifkan' }}
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
   
    <app-spinner v-if="isLoading"></app-spinner>
  </div>
</template>
<script>
import axios from 'axios'
import Spinner from '@/components/plugins/Spinner'
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import moment from 'moment'
export default {
  name: 'user-detail',
  components: {
    'app-spinner': Spinner,
    DatePicker
  },
  data: function () {
    return {
      teacher: {},
      isLoading: true,
      pageNumber: 1,
      query: '',
      isMapping: false,
      isBulkModal: false,
      ossEndpoint: process.env.OSS_ENDPOINT,
      ossBucketName: process.env.OSS_BUCKET_NAME,
      listMapelScope: [],
      expiredAtModel: null,
      mapels: []
    }
  },
  methods: {
    loadDetailData: function () {
      var context = this
      var token = this.$ls.get('token');
      var url = process.env.API_BASE_URL + '/account/teacher/' + context.$route.params.id

      this.isLoading = true
      var http = axios.create({
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + token
        }
      })

      http.get(url)
        .then(function (response) {
          context.teacher = response.data
          context.listMapelScope = response.data.scopes
          context.expiredAtModel = response.data.expired_at
        })
        .catch(function (error) {
          console.log(error.message)
        })
        .then(function () {
          context.isLoading = false
        })
    },
    loadMapels: function (pageNumber = 1) {
      var context = this
      var token = this.$ls.get('token');
      var url = process.env.API_BASE_URL + '/account/teacher/scopes'

      // this.isLoading = true
      var http = axios.create({
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + token
        }
      })

      http.get(url)
      .then(function(response) {
        context.mapels = response.data
        for (let index = 0; index < context.mapels.length; index++) {
          context.mapels[index].display_name = context.mapels[index].displayName
          
        }
        
      })
      .catch(function (error) {
        console.log(error.message)
      })
      .then(function() {
        // context.isLoading = false
      })
    },

    updateTanggalScope() {
      var context = this
          if(moment(context.expiredAtModel + ' 23:59:59').unix() < moment().unix()){
            alert('Tanggal tidak valid')
            context.loadDetailData()
          }else if(context.expiredAtModel === null || context.expiredAtModel === ''){
            alert('Tanggal Expired wajib diisi')
          } else {
            if (confirm("Anda yakin akan mengubah data ini?") == true) {
            var token = this.$ls.get('token');
            var url = process.env.API_BASE_URL + '/account/teacher/' + context.$route.params.id
      
            this.isLoading = true
            var http = axios.create({
              headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token
              }
            })

            let convertIdMapelScope = []
            context.teacher.scopes.forEach(element => {
              convertIdMapelScope.push(element.id)
            });
            http.put(url, {'expired_at': moment(context.expiredAtModel + ' 23:59:59').unix(), 'scope_ids': convertIdMapelScope })
            .then(function (response) {
              console.log(response)
              alert('Data berhasil diperbaharui')
              context.loadDetailData()
              context.$router.push('/teachers')
            })
            .catch(function (error) {
              console.log(error.message)
              alert('Data gagal diperbaharui')
              context.loadDetailData()
            })
            .then(function () {
              context.isLoading = false
            })
          }
          }
    },
    addMapel(v){
      console.log(v)
      let aa = this.teacher.scopes.find(function(element) {
        return element.id == v.id
      })
      if(!aa) this.teacher.scopes.push(v)
    },
    removeMapel(v){
      for (let index = 0; index < this.teacher.scopes.length; index++) {
        const element = this.teacher.scopes[index];
        if(element.id === v.id) this.teacher.scopes.splice(index, 1)
        
      }
    },
  },
  mounted: function() {
    this.loadDetailData()
    this.loadMapels()
  },
  
}
</script>



// WEBPACK FOOTER //
// TeacherDetail.vue?03f694f0